import {QuestionList} from '../types';
import Orn1 from '../img/orn1.svg'

export const BeginList: QuestionList = [{
    id: 0,
    img: Orn1,
    rightAnswerId: 1,
    rightAnswerExplanation: ``,
    question: `
<p><b class="gra">Стріха, маківка чи картуш?</b></p>
<p><b class="gra__under">Перевір свої знання українських архітектури та побуту</b></p>
<p>У травні за сприяння міжнародної компанії у сфері аграрних та харчових технологій МХП та благодійного фонду <a href="https://mhpgromadi.org.ua/" target="_blank">«МХП-Громаді»</a>  було відкрито новий вхід до Національного музею архітектури та побуту України. Він став своєрідним етнопорталом, який переносить відвідувачів із сучасного та урбанізованого світу в українські села XVII-XX століття з їхньою історією, архітектурою, побутом, світоглядом та традиціями..</p>
<p>Пройдіть тест та перевірте свої знання з української архітектури та побуту!</p>
    `,
    answers: [
        {
            id: 1,
            text: 'Почати',
        },
    ],
}
]
